import { getFullFieldPath } from '../../utils';

import { FINANCE_TAB_KEY } from './constants';

export const getFullFinancePath = (fieldId) => getFullFieldPath(FINANCE_TAB_KEY, fieldId);
